import { Hammer } from 'lucide-react';
import { PageHeader } from '../components/ui/page-header.tsx';

/**
 * Bereich, der in einer späteren Story gebaut wird. Redesign OpenAI-Stil (N40): ruhiger leerer Zustand in der Mitte –
 * Symbol im Kreis, ein Satz, keine Karte voller Leere.
 */
export function PlaceholderPage({ title }: { title: string }) {
  return (
    <>
      <PageHeader title={title} />
      <section className="card-box flex animate-fade-in flex-col items-center gap-space-4 rounded-card px-space-6 py-16 text-center">
        <span aria-hidden className="flex size-12 items-center justify-center rounded-full bg-background text-ink-2">
          <Hammer size={22} strokeWidth={1.5} />
        </span>
        <div className="flex max-w-sm flex-col gap-space-1">
          <p className="text-tile-title font-semibold tracking-[-0.01em] text-ink">Dieser Bereich wird gerade gebaut.</p>
          <p className="text-row text-ink-3">{`„${title}“ kommt mit einem der nächsten Schritte.`}</p>
        </div>
      </section>
    </>
  );
}
